import {
  DeleteSchedulePathParamType,
  DeleteScheduleResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { scheduleKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const deleteSchedule = async (
  data: ApiRequest<any, DeleteSchedulePathParamType>
) => {
  const resp = await api.delete<DeleteScheduleResponseBodyType>(
    `/v2/schedules/${data.pathParams.scheduleId}`,
    data.body
  );
  return resp.data;
};

export const useDeleteSchedule = (experienceId?: string) => {
  const queryClient = useQueryClient();

  return useMutation<
    DeleteScheduleResponseBodyType,
    Error,
    ApiRequest<any, DeleteSchedulePathParamType>,
    any
  >({
    mutationFn: async (data: ApiRequest<any, DeleteSchedulePathParamType>) =>
      deleteSchedule(data),
    onSuccess: async (data, payload) => {
      if (experienceId) {
        void queryClient.invalidateQueries({
          queryKey: scheduleKeys.one(experienceId),
        });
      }
    },
  });
};
